
import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebase';
import { TaxCaseDocumentDoc, TaxDocument } from '../types';
import { subscribeToDocuments } from '../services/firestoreService';
import { useAuth } from '../context/AuthContext';

interface UseTaxCaseDocumentsResult {
  documents: TaxDocument[];
  loading: boolean;
  error: string | null;
}

export const useTaxCaseDocuments = (caseId: string | undefined): UseTaxCaseDocumentsResult => {
  const [documents, setDocuments] = useState<TaxDocument[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { firmId } = useAuth();

  useEffect(() => {
    if (!caseId) {
      setDocuments([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    // Use unified service for demo-aware subscriptions
    const unsubscribe = subscribeToDocuments(firmId || 'hannah-financial-demo', caseId, (results) => {
       setDocuments(results);
       setLoading(false);
    });

    return () => unsubscribe();
  }, [caseId, firmId]);

  return { documents, loading, error };
};
